/*
  Pure Grounds: "Add both" on the Pairs well with section. Posts the page product's selected variant
  (with the grind chosen in the product form) and the first pick's variant in one /cart/add.js call,
  then renders the drawer the way the add-on does. The product form lives in the main section whose id
  shares this section's prefix (template--…__main), so no coupling in Liquid is needed.
*/
if (!customElements.get('pair-with')) {
  customElements.define(
    'pair-with',
    class PairWith extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.pair-with__both-button');
        this.errorEl = this.querySelector('.pair-with__error');
        if (!this.button || this.button.dataset.bound === 'true') return;
        this.button.dataset.bound = 'true';
        this.button.addEventListener('click', this.addBoth.bind(this));
      }

      get mainForm() {
        const mainId = (this.dataset.section || '').replace(/__[^_]+$/, '__main');
        return (
          document.getElementById('product-form-' + mainId) ||
          document.querySelector('#MainContent product-form form[data-type="add-to-cart-form"]')
        );
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      addBoth() {
        const form = this.mainForm;
        const idInput = form && form.querySelector('input[name="id"]');
        const pairId = Number(this.dataset.pairVariantId);
        if (!idInput || !pairId || !window.PGC || !window.PGC.cartAdd) return;

        const items = [{ id: Number(idInput.value), quantity: 1 }, { id: pairId, quantity: 1 }];
        const grind = form.querySelector('select[name="properties[Grind Size]"]');
        if (grind && grind.value) items[0].properties = { 'Grind Size': grind.value };
        if (this.dataset.pairGrind) items[1].properties = { 'Grind Size': this.dataset.pairGrind };

        const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections =
          cartElement && typeof cartElement.getSectionsToRender === 'function'
            ? cartElement.getSectionsToRender().map((section) => section.id)
            : undefined;

        if (this.errorEl) this.errorEl.hidden = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;

        window.PGC.cartAdd(items, { sections: sections })
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }
            if (cartElement && typeof cartElement.renderContents === 'function') {
              cartElement.renderContents(response);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
            document.dispatchEvent(new CustomEvent('pair-with:added', { detail: response }));
          })
          .catch(() => this.showError('Sorry, that did not go through. Please try again.'))
          .finally(() => {
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          });
      }
    }
  );
}
